<template>
  <EmptyRouterView />
</template>
<script>
import EmptyRouterView from '@components/EmptyRouterView';

export default {
  components: {
    EmptyRouterView
  }
};
</script>
<style scoped></style>
